import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { SyncOutlined } from '@ant-design/icons';
import { Tag } from 'antd';

import { RootState } from 'store';
import usePetListingWorkflowStatus from 'shared/hooks/usePetListingWorkflowStatus';
import {
  ListingWorkflowStatusIdTypes,
  PetWorkflowStatusIdTypes,
} from 'shared/types';

import './WorkflowStatusTag.scss';

interface Props {
  workflowStatusId: ListingWorkflowStatusIdTypes | PetWorkflowStatusIdTypes;
  useAcronym?: boolean;
  showOuterLabel?: boolean;
}

function WorkflowStatusTag(props: Props): ReactElement {
  const { workflowStatusId, useAcronym, showOuterLabel } = props;
  const petWorkflowStatus = usePetListingWorkflowStatus(workflowStatusId);
  const statusBadgeModifierClass = `WorkflowStatusTag__badge--${petWorkflowStatus.slug}`;
  const listingLoadingTransition = useSelector(
    (state: RootState) => state.listingReducer.loadingTransition
  );

  return (
    <section className="WorkflowStatusTag">
      <Tag
        className={`WorkflowStatusTag__badge  ${statusBadgeModifierClass}`}
        icon={listingLoadingTransition && <SyncOutlined spin />}
      >
        {useAcronym ? petWorkflowStatus.acronym : petWorkflowStatus.label}
      </Tag>
      {showOuterLabel && (
        <span className="WorkflowStatusTag__outer-label">
          {petWorkflowStatus.label}
        </span>
      )}
    </section>
  );
}

export default WorkflowStatusTag;
